import React, { lazy, Suspense } from 'react';
import { Container } from 'react-bootstrap';
import Header from '#src/components/header';
import { LoadingProgressBar } from '#src/components/loading-progress-bar';
import { StateMachineContext } from '#src/state-machine/context';
import { getDownloadData, getView } from '#src/state-machine/selectors';
import { extractExportData, generateCsvFilename } from '#src/utils/export-data';
import { exportChartToPng, exportMapToPng } from '#src/utils/export-png';
import { CSVConverter } from '#src/utils/json2csv';

const ChartView = lazy(() => import('#src/components/chart-view/chart-layout'));
const MapView = lazy(() => import('#src/components/map-view/map-layout'));
const TableView = lazy(() => import('#src/components/table-view/table-layout'));

export function App() {
  const view = StateMachineContext.useSelector(getView);
  const downloadData = StateMachineContext.useSelector(getDownloadData);
  const state = StateMachineContext.useSelector((state) => state);

  const onDownload = async (option: 'csv' | 'png') => {
    if (option === 'csv' && downloadData != null) {
      const exportData = extractExportData(state);
      const filename = generateCsvFilename(exportData);
      const csv = CSVConverter.convert(downloadData);
      CSVConverter.download(csv, filename);
    }
    if (option === 'png') {
      const exportData = extractExportData(state);
      if (view === 'chart') {
        await exportChartToPng(exportData);
      } else if (view === 'map') {
        await exportMapToPng(exportData);
      }
    }
  };

  let viewComponent = null;
  switch (view) {
    case 'chart':
      viewComponent = <ChartView onDownload={onDownload} />;
      break;
    case 'map':
      viewComponent = <MapView onDownload={onDownload} />;
      break;
    case 'table':
      viewComponent = <TableView onDownload={onDownload} />;
      break;
  }

  return (
    <div>
      <Header />
      <Container fluid className='p-3 p-lg-5 position-relative'>
        <LoadingProgressBar />
        <Suspense fallback={null}>{viewComponent}</Suspense>
      </Container>
    </div>
  );
}
